/** these are ids from database */
export enum WireTransferRecipientEnum {
  client = 1,
  thirdParty = 2
}